import { getCookie } from '@utiljs/cookie';
import { IQueryMenuItem, IMenuInfo } from '../api/define';

/** 获取匹配的菜单 - 前端自定义菜单匹配规则 */
const getMatchedMenu = (currentHash: string, menuInfo: IMenuInfo) => {
    const parentMatchRegExp = new RegExp(`^${currentHash}`, 'gi');
    const matchInfo = {
        lastSubMatchIndex: 0,
        lastSupMatchIndex: 0,
    };
    const urlOrigin = window.location.origin;
    if (currentHash.indexOf(urlOrigin) > -1) {
        currentHash = currentHash.substring(urlOrigin.length);
    }
    let matchedMenuCode;

    try {
        const menuKeys = Object.keys(menuInfo);
        let matchedFlag = false;
        for (let i = 0; i < menuKeys.length; i++) {
            if (matchedFlag) break;
            const key = menuKeys[i];
            const menuLists = menuInfo[key] || [];
            for (let j = 0; j < menuLists.length; j++) {
                const menuItem = menuLists[j] || {};
                const url = menuItem.url || '';
                /** 配置接口下发Url */
                let infoUrl = url.split('?')[0];

                if (menuItem.prefix === 'proxy') {
                    // 第三方接入菜单，需加上 proxy 前缀
                    infoUrl = `${window.CommConstants.eappBaseUrl}${infoUrl}`;
                }
                if (infoUrl === currentHash) {
                    // 优先精准匹配
                    matchedMenuCode = key;
                    matchedFlag = true;
                    break;
                } else if (infoUrl.length < currentHash.length) {
                    // 其次走子路径匹配
                    if (!menuItem.regExp) {
                        menuItem.regExp = new RegExp(`^${infoUrl}`, 'gi');
                    }

                    menuItem.regExp.lastIndex = 0;
                    if (menuItem.regExp.test(currentHash)) {
                        //子路径匹配最多的获胜
                        const lastSubIndex = matchInfo.lastSubMatchIndex || 0;
                        const nowSubIndex = menuItem.regExp.lastIndex;
                        if (lastSubIndex < nowSubIndex) {
                            matchedMenuCode = key;

                            matchInfo.lastSubMatchIndex = nowSubIndex;
                        }
                    }
                } else {
                    //最后父路径匹配
                    if (parentMatchRegExp.test(infoUrl)) {
                        //父路径匹配最少的获胜
                        const lastSupIndex = matchInfo.lastSupMatchIndex || 0;
                        const nowSupIndex = infoUrl.length;
                        if (lastSupIndex === 0 || lastSupIndex > nowSupIndex) {
                            matchedMenuCode = key;
                            matchInfo.lastSupMatchIndex = nowSupIndex;
                        }
                    }
                }
            }
        }
        if (!matchedMenuCode) {
            if (menuKeys.length) {
                try {
                    if (window.Owl) {
                        //如果不是#/new_fe，#/gw，或#有效url的情况，上报
                        const url = window.location.hash.split('?')[0];
                        if (
                            !url.startsWith('#/new_fe/') &&
                            !url.startsWith('#/gw') &&
                            !url.startsWith('#http')
                        ) {
                            Owl.addError(
                                {
                                    name: `URL: ${url}`,
                                    msg: `Origin: ${window.location.href}`,
                                },
                                {
                                    level: Owl.errorModel.LEVEL.WARN,
                                    combo: false,
                                    tags: {
                                        cityid: getCookie('cityId'),
                                        acctId: getCookie('acctId'),
                                        wmPoiId: getCookie('wmPoiId'),
                                    },
                                    category: 'LEFT_MENU_UNMATCH_URL',
                                },
                            );
                        }
                    }
                } catch (e) {
                    //
                }
            }
        }
    } catch (e) {
        //
    }
    return matchedMenuCode || '';
};

type MatchedMenuType = {
    /** 高亮的一级菜单 */
    menuCode: string;
    /** 高亮的一级菜单名字 */
    menuName: string;
    /** 高亮的二级菜单 */
    subMenuCode: string;
    /** 高亮的二级菜单名字 */
    subMenuName: string;
};

/** 获取匹配菜单的二级菜单 */
const getMatchedInfo = (matchedMenuCode: string, leftMenuList: IQueryMenuItem[]) => {
    const matchedMenu = {
        menuCode: '',
        menuName: '',
        subMenuCode: '',
        subMenuName: '',
    };
    leftMenuList.forEach(menu => {
        if (menu.subMenus && menu.subMenus.length) {
            const matchedSubMenu = menu.subMenus.find(subItem => {
                return subItem.menuCode === matchedMenuCode;
            });
            if (matchedSubMenu) {
                matchedMenu.subMenuCode = matchedSubMenu.menuCode;
                matchedMenu.subMenuName = matchedSubMenu.subMenuName;
                matchedMenu.menuName = menu.menuName;
                matchedMenu.menuCode = menu.menuCode;
            }
        } else {
            if (menu.menuCode === matchedMenuCode) {
                matchedMenu.menuName = menu.menuName;
                matchedMenu.menuCode = menu.menuCode;
            }
        }
    });

    return matchedMenu;
};

function menuMatch(
    hash: string,
    menuInfo: IMenuInfo,
    leftMenuList: IQueryMenuItem[],
): MatchedMenuType {
    let matchedMenu = {
        menuCode: '',
        menuName: '',
        subMenuCode: '',
        subMenuName: '',
    };
    let matchedCode = '';

    const currentHash = hash.split('?')[0];
    /** 匹配到的menu */
    //首次进入如果hash是空则跳转到左侧菜单的第一个页面
    if (hash === '') {
        const firstMenu = leftMenuList && leftMenuList[0];
        matchedMenu.menuCode = firstMenu?.menuCode;
        matchedMenu.menuName = firstMenu?.menuName;
        if (firstMenu.subMenus?.length) {
            matchedMenu.subMenuCode = firstMenu.subMenus[0].menuCode;
            matchedMenu.subMenuName = firstMenu.subMenus[0].subMenuName;
        }
    } else {
        //优先走前端自定义菜单匹配规则
        // 获取匹配的二级菜单code
        matchedCode = getMatchedMenu(currentHash, menuInfo);

        // 根据menuList获取所有菜单信息
        matchedMenu = getMatchedInfo(matchedCode, leftMenuList);
    }

    return matchedMenu;
}

// eslint-disable-next-line import/prefer-default-export
export { menuMatch };
